import { Directive, output } from '@angular/core';

@Directive({
    selector: '[xuiDragDrop]',
    host: {
      '[class]': 'elementClass',
      '(dragover)': 'onDragOver($event)',
      '(dragleave)': 'onDragLeave($event)',
      '(drop)': 'ondrop($event)'
    }
})
export class DragDropDirective {
    readonly fileDropped = output<any>();
    elementClass = '';

    // Dragover listener
    onDragOver(event: DragEvent) {
        event.preventDefault();
        event.stopPropagation();
        this.elementClass = 'active';
    }

    // Dragleave listener
    onDragLeave(event: DragEvent) {
        event.preventDefault();
        event.stopPropagation();
        this.elementClass = '';
    }

    // Drop listener
    ondrop(event: DragEvent) {
        event.preventDefault();
        event.stopPropagation();
        this.elementClass = '';
        const files = event.dataTransfer?.files;
        if (files && files.length > 0) {
            this.fileDropped.emit(files);
        }
    }
}
